import type { Profile } from '../types/profile';
import type { TeamSummaryMember } from '../types/teamSummary';
import type { UserAuditReportRow } from '../types/userAudit';
import { profileToAuditRow } from './clientAuditUtils';

type ProfileBusiness = NonNullable<Profile['business']> & {
  clientId?: string;
  client?: { name: string };
};

export function profileToUserAuditRow(
  profile: Profile,
  teamMember?: TeamSummaryMember,
): UserAuditReportRow {
  const business = profile.business as ProfileBusiness | undefined;
  const base = profileToAuditRow(
    profile,
    profile.businessId,
    business?.name || '—',
    teamMember,
  );

  return {
    ...base,
    clientId: business?.clientId ?? null,
    clientName: business?.client?.name || '—',
    accountStatus: profile.status,
    roles: profile.roles ?? [],
    userId: profile.userId,
    slackActivity: !!profile.metadata?.slackActivity,
  };
}

export function sortUserAuditRows(rows: UserAuditReportRow[]): UserAuditReportRow[] {
  return [...rows].sort((a, b) => a.displayName.localeCompare(b.displayName));
}
